"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var redux_1 = require("redux");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("utils/hooks");
var populated_1 = require("utils/selectors/populated");
var single_1 = require("utils/selectors/single");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var ListReports = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var history = (0, react_router_1.useHistory)();
    var analysisBundles = (0, react_redux_1.useSelector)(populated_1.selectPopQuoteAnalysisBundles);
    var _a = __read((0, hooks_1.useSubmitter)('quote_analysis_bundles'), 2), submitBundle = _a[0], bundleIsSubmitting = _a[1];
    if (!(0, react_redux_firebase_1.isLoaded)(analysisBundles)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var createAnalysisBundle = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var quoteAnalysisId, bundleRef;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    quoteAnalysisId = Date.now().toString(36);
                    return [4 /*yield*/, submitBundle({
                            companyId: profile.companyId,
                            userId: profile.id,
                            serviceId: value.value,
                            quoteAnalysisIds: [quoteAnalysisId],
                            quoteAnalysisMap: (_a = {}, _a[quoteAnalysisId] = { pricingPlanRows: [], currency: 'AUD' }, _a),
                        })];
                case 1:
                    bundleRef = _b.sent();
                    history.push("/benchmarks/quote-analyser/".concat(bundleRef.id));
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: [{ label: 'HubSpot', value: 'bLeYfME82Bm9Sayrhpt6' }]
                    .filter(function (_a) {
                    var value = _a.value;
                    return !(analysisBundles === null || analysisBundles === void 0 ? void 0 : analysisBundles.find(function (qAB) { return qAB.serviceId === value; }));
                }), btnProps: { icon: faPlus_1.faPlus, size: 'small' }, label: "Add a quote", placeholder: "Select a tool", onChange: createAnalysisBundle, noOptionsText: "Benchmarks not found", value: null, isDisabled: bundleIsSubmitting }), analysisBundles.map(function (aB) { return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/benchmarks/quote-analyser/".concat(aB.id) }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: aB.service }) }), aB.id)); })] }));
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'serviceName', order: 1 }); })(ListReports);
